'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');

function OfferTypeLabel({ coupon, className }) {
  const types = {
    OnlineCode: {
      key: 'CodeOfferType',
      classType: `${className}-code`,
    },
    OnlineDeal: {
      key: 'DealOfferType',
      classType: `${className}-deal`,
    },
    OnlineSale: {
      key: 'SaleOfferType',
      classType: `${className}-deal`,
    },
  };

  const { key = '', classType = '' } = types[coupon.offerType] || {};

  return h(
    Translate,
    {
      tag: 'span',
      attrs: { class: `${className} ${classType}` },
    },
    `js.modules.shared.${key}`
  );
}

module.exports = OfferTypeLabel;
